module.exports = __webpack_public_path__ + "media/images/header_icons-0a43087750de3d91e8c2694da7d86b19.svg";